<template>
  <div class="p-3">
    <b-overlay :show="isRunningQuery" rounded="sm">
      <bot-client></bot-client>
      <b-row>
        <b-col
            cols="12"
            sm="6"
            lg="3"
            :class="{ 'smartgrabber-panel-hidden': hideSidePanel }"
            class="p-3"
        >
          <b-row>
            <b-col>
              <b-alert show variant="warning" dismissible>
                <h6>Notice: SmartGrabber Deprecated</h6>
                <small>
                  This report is being deprecated and will no longer be available after <strong>30 November 2024</strong>. The Big Query report is set to replace this in the future.
                  If you still do not have permission to access Big Query report please request for it through RMS immediately. 
                  For any enquiry, please email to biteam@ogglobal.net.
                </small>
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="mb-3">
                <div>Cubes</div>
                <b-select
                    size="sm"
                    v-model="selectedCube"
                    :options="cubes"
                    :disabled="loadingCubeData"
                />
                <b-badge class="mt-2" variant="light" v-if="selectedCube"
                > Jobtime: 
                  <span v-if="jobtime">{{ jobtime }}</span>
                  <span v-else-if="isLoadingJobTime">
                    <b-spinner small></b-spinner>
                  </span>
                  <span v-else>...</span>
                </b-badge>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="selectedCube">
            <b-col cols="12">
              <div class="mb-3" v-if="!isLoadingTemplate && !loadingCubeData">
                <div>Templates</div>
                <treeselect
                    v-model="selectedTemplate"
                    :options="templates"
                    @input="LoadTemplate"
                ></treeselect>
                <div class="mt-2">
                  <b-button
                      v-if="selectedMeasures.length > 0"
                      variant="outline-primary"
                      size="sm"
                      class="float-left mr-1"
                      title="Create a new template"
                      @click="
                      modalTemplate = true;
                      isEditTemplate = false;
                    "
                  >
                    <b-icon-plus/>
                  </b-button>
                  <b-button
                      v-if="selectedTemplate"
                      variant="outline-primary"
                      size="sm"
                      class="float-left mr-1"
                      title="Edit selected template"
                      @click="
                      modalTemplate = true;
                      isEditTemplate = true;
                      template = Object.assign({}, editTemplate);
                    "
                  >
                    <b-icon-pencil/>
                  </b-button>
                  <b-button
                      v-if="selectedTemplate"
                      variant="outline-primary"
                      size="sm"
                      class="float-left mr-1"
                      title="Delete selected template"
                      @click="DeleteTemplate"
                  >
                    <b-icon-trash/>
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div v-if="loadingCubeData">
                <b-spinner small></b-spinner>
              </div>
              <div v-if="Boolean(cubedata.measureGroups)">
                <smartgrabber-panel
                    :cubedata="cubedata"
                    :measureGroups.sync="selectedMeasureGroups"
                    :levels.sync="selectedLevels"
                    :measures.sync="selectedMeasures"
                    :filters.sync="selectedFilters"
                    @add-remove-filter="AddOrRemoveFilter($event)"
                    @add-filter="AddFilter($event)"
                />
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="1" class="smartgrabber-divider d-none d-sm-inline-block">
          <div
              class="smartgrabber-hide-options"
              @click="hideSidePanel = !hideSidePanel"
          >
            <b-icon-chevron-double-left v-if="!hideSidePanel"/>
            <b-icon-chevron-double-right v-if="hideSidePanel"/>
          </div>
          <div class="smartgrabber-panel"></div>
        </b-col>

        <b-col class="smartgrabber-panel">
          <b-row
              class="mb-3"
              :class="{
              'smartgrabber-panel-hidden': selectedFilters.length <= 0,
            }"
          >
            <b-col cols="12">
              <div>
                <b-row
                    v-for="filter in selectedFilters"
                    :key="filter.level.levelId"
                >
                  <b-col cols="12">
                    <b-row class="my-1">
                      <b-col cols="1" class="text-right max-width-50">
                        <span
                            v-if="!filter.isLoading"
                            class="clickable align-middle"
                            @click="RemoveFilter(filter.level)"
                        >
                          <b-icon-x/>
                        </span>
                        <b-spinner
                            v-if="filter.isLoading"
                            small
                            variant="primary"
                            label="Spinning"
                        ></b-spinner>
                      </b-col>
                      <b-col
                          cols="4"
                          xl="3"
                          class="max-width-170 d-inline-block text-truncate"
                      >
                        <span class="align-middle" style="font-size:0.9em;">{{
                            filter.level.levelCaption
                          }}</span>
                      </b-col>
                      <b-col cols="7" xl="8" class="align-middle">
                        <div
                            v-if="
                            filter.level.levelDbType === 'GENERAL' ||
                              filter.level.levelDbType === 'YEAR'
                          "
                        >
                          <filter-general
                              :filter="filter"
                              :selectedCube="selectedCube"
                              v-model="
                              selectedFilterOptions[filter.level.levelId]
                            "
                          ></filter-general>
                        </div>
                        <div v-if="filter.level.levelDbType === 'BRAND'">
                          <filter-brand
                              :filter="filter"
                              v-model="
                              selectedFilterOptions[filter.level.levelId]
                            "
                              :brands="cubedata.brands"
                          ></filter-brand>
                        </div>
                        <div
                            v-else-if="
                            filter.level.levelDbType === 'DATE1' ||
                              filter.level.levelDbType === 'DATE2'
                          "
                        >
                          <filter-date
                              :filter="filter"
                              v-model="
                              selectedFilterOptions[filter.level.levelId]
                            "
                          ></filter-date>
                        </div>
                        <div
                            v-else-if="
                            filter.level.levelDbType === 'MONTH1' ||
                              filter.level.levelDbType === 'MONTH2'
                          "
                        >
                          <filter-month
                              :filter="filter"
                              v-model="
                              selectedFilterOptions[filter.level.levelId]
                            "
                          ></filter-month>
                        </div>
                        <div
                            v-else-if="filter.level.levelDbType === 'MEMBERCODE'"
                        >
                          <div
                              v-if="
                              GetCubeType(selectedCube) === 'NEW' ||
                                GetCubeType(selectedCube) === 'OLD' ||
                                GetCubeType(selectedCube) === 'ALL'
                            "
                          >
                            <filter-member-code
                                :filter="filter"
                                v-model="
                                selectedFilterOptions[filter.level.levelId]
                              "
                                :brands="cubedata.brands"
                            ></filter-member-code>
                          </div>
                          <div v-else>
                            <filter-member-code-rolap
                                :filter="filter"
                                v-model="
                                selectedFilterOptions[filter.level.levelId]
                              "
                            ></filter-member-code-rolap>
                          </div>
                        </div>
                        <div
                            v-else-if="
                            filter.level.levelDbType === 'AFFILIATECODE'
                          "
                        >
                          <filter-affiliate-code
                              :filter="filter"
                              v-model="
                              selectedFilterOptions[filter.level.levelId]
                            "
                          ></filter-affiliate-code>
                        </div>
                        <div
                            v-else-if="filter.level.levelDbType === 'USERNAME'"
                        >
                          <filter-user-name
                              :filter="filter"
                              v-model="
                              selectedFilterOptions[filter.level.levelId]
                            "
                          ></filter-user-name>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row
              :class="{
              'smartgrabber-panel-hidden':
                selectedLevels.length <= 0 && selectedMeasures.length <= 0,
            }"
          >
            <b-col cols="12" class="mb-3">
              <span
                  class="align-vertical mr-2"
                  title="Click and drag to rearrange the columns"
              >
                <b-icon-exclamation-circle/>
              </span>
              <draggable
                  v-model="selectedLevels"
                  v-bind="dragOptions"
                  group="levels"
                  @start="isDragging = true"
                  @end="isDragging = false"
                  style="display:inline"
              >
                <b-badge
                    variant="primary"
                    v-for="level in selectedLevels"
                    :key="level.levelId"
                    scope="col"
                    class="clickable mr-1"
                >
                  {{ level.levelCaption + ' ' }}
                  <span
                      class="clickable"
                      @click="
                      selectedLevels.splice(
                        selectedLevels.findIndex(v => v === level),
                        1
                      )
                    "
                  >
                    <b-icon-x/>
                  </span>
                </b-badge>
              </draggable>
              <draggable
                  v-model="selectedMeasures"
                  v-bind="dragOptions"
                  group="measures"
                  @start="isDragging = true"
                  @end="isDragging = false"
                  style="display:inline"
              >
                <b-badge
                    variant="info"
                    v-for="measure in selectedMeasures"
                    :key="measure.measureId"
                    scope="col"
                    class="clickable mr-1"
                >
                  {{ measure.measureCaption + ' ' }}
                  <span
                      class="clickable"
                      @click="
                      selectedMeasures.splice(
                        selectedMeasures.findIndex(v => v === measure),
                        1
                      )
                    "
                  >
                    <b-icon-x/>
                  </span>
                </b-badge>
              </draggable>
            </b-col>
          </b-row>
          <b-row
              :class="{
              'smartgrabber-panel-hidden': selectedMeasures.length <= 0,
            }"
          >
            <b-col cols="12">
              <b-button
                  variant="primary"
                  size="sm"
                  class="float-right"
                  @click="GetData"
              >Submit
              </b-button>
              <b-button
                  variant="primary"
                  size="sm"
                  class="float-right mr-1"
                  @click="ExportData"
              >
                <b-icon-file-earmark-excel scale="0.8"/>
                Export
              </b-button>
              <b-button
                  variant="secondary"
                  size="sm"
                  class="float-right mr-1"
                  @click="GetMdxQuery"
              >
                <b-icon-eye scale="0.8"/>
                Show MDX
              </b-button>
            </b-col>
          </b-row>
          <b-row :class="{ 'smartgrabber-panel-hidden': items.length <= 0 }">
            <b-col cols="12">
              <div ref="table-container">
                <b-row class="mb-3">
                  <b-col>
                    <dataset
                        class="float-right mt-3"
                        @btnClicked="retrieveMdx"
                        @formSubmitted="saveDataset"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <data-viewer
                        :items="items"
                        :fields="fields"
                        :isBusy="isBusy"
                    ></data-viewer>
                  </b-col>
                </b-row>
                <!--                <small class="text-muted"-->
                <!--                >Current Page: {{ currentPage }}. Total rows: {{ rows }}</small-->
                <!--                >-->
                <!--                <b-pagination-->
                <!--                    v-model="currentPage"-->
                <!--                    :total-rows="rows"-->
                <!--                    :per-page="perPage"-->
                <!--                    size="sm"-->
                <!--                    align="right"-->
                <!--                    limit="10"-->
                <!--                    v-if="rows > 0"-->
                <!--                ></b-pagination>-->
                <!--                <dataset class="float-right mb-3" @btnClicked="retrieveMdx" @formSubmitted="saveDataset"/>-->
                <!--                <b-table-->
                <!--                    class="smartgrabber-table"-->
                <!--                    bordered-->
                <!--                    small-->
                <!--                    responsive-->
                <!--                    sticky-header="85vh"-->
                <!--                    :items="items"-->
                <!--                    :fields="fields"-->
                <!--                    :per-page="perPage"-->
                <!--                    :current-page="currentPage"-->
                <!--                    :busy="isBusy"-->
                <!--                    :sort-compare="CustomSortFunction"-->
                <!--                >-->
                <!--                  <template v-slot:table-busy>-->
                <!--                    <div class="text-center my-2">-->
                <!--                      <b-spinner class="align-middle"></b-spinner>-->
                <!--                      <strong>Loading...</strong>-->
                <!--                    </div>-->
                <!--                  </template>-->
                <!--                </b-table>-->
              </div>
            </b-col>
          </b-row>
          <div v-if="httpIsBusy" class="fixed-bottom text-right mb-2 pr-5">
            <b-spinner small class="align-middle"/>
            <small>{{ ' Loading...' }}</small>
          </div>
        </b-col>
      </b-row>

      <!--      <b-modal-->
      <!--          v-model="isRunningQuery"-->
      <!--          size="sm"-->
      <!--          hide-footer-->
      <!--          hide-header-->
      <!--          centered-->
      <!--          no-close-on-backdrop-->
      <!--          no-close-on-esc-->
      <!--      >-->
      <!--        <div style="text-align: center">-->
      <!--          <b-spinner small class="align-middle"/>-->
      <!--          <small>{{ ' Loading...' }}</small>-->
      <!--        </div>-->
      <!--      </b-modal>-->

      <b-modal v-model="modalTemplate" title="Template">
        <b-row>
          <b-col cols="12">
            <b-form ref="template-form">
              <b-input
                  size="sm"
                  type="text"
                  placeholder="Template Name"
                  v-model="template.templateName"
                  required
                  @focus="
                  $event.target.setSelectionRange(0, $event.target.value.length)
                "
              />
            </b-form>
          </b-col>
        </b-row>
        <template v-slot:modal-footer="{ cancel }">
          <b-button variant="secondary" @click="cancel()">Cancel</b-button>
          <b-button variant="primary" @click="AddOrEditTemplate"
          >Submit
          </b-button>
        </template>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
/*global _*/
import axios from 'axios';
import draggable from 'vuedraggable';
//import cubedata from '@/views/datagrabber/cubedata';
import application from '@/mixins/application';

import smartgrabberPanel from '@/components/datagrabber/SmartGrabberPanel';
import filterGeneral from '@/components/datagrabber/FiltersGeneral';
import filterDate from '@/components/datagrabber/FiltersDate';
import filterMonth from '@/components/datagrabber/FiltersMonth';
import filterAffiliateCode from '@/components/datagrabber/FiltersAffiliateCode';
import filterMemberCode from '@/components/datagrabber/FiltersMemberCode';
import filterMemberCodeRolap from '@/components/datagrabber/FiltersMemberCodeRolap';
import filterBrand from '@/components/datagrabber/FiltersBrand';
import FilterUserName from '@/components/datagrabber/FilterUserName';
import botClient from '@/components/BotClient';
import Dataset from '@/components/datagrabber/Dataset';
import DataViewer from '@/components/datagrabber/DataViewer';

export default {
  name: 'SmartGrabber',
  mixins: [application],
  components: {
    draggable,
    smartgrabberPanel,
    filterDate,
    filterMonth,
    filterGeneral,
    filterAffiliateCode,
    filterMemberCode,
    filterMemberCodeRolap,
    filterBrand,
    FilterUserName,
    botClient,
    Dataset,
    DataViewer,
  },
  data() {
    return {
      modalTemplate: false,
      isEditTemplate: false,
      template: {
        id: -1,
        templateName: '',
        templateObject: '',
        cubeConfigId: null,
      },
      editTemplate: {
        id: -1,
        templateName: '',
      },
      defaultTemplate: {
        id: -1,
        templateName: '',
        templateObject: '',
        cubeConfigId: -1,
      },

      cubes: [],
      selectedCube: null,
      selectedTemplate: null,
      templates: [],
      cubedata: {},
      selectedMeasureGroups: [],
      selectedMeasures: [],
      selectedLevels: [],
      selectedFilters: [],
      selectedFilterOptions: {},

      items: [],
      perPage: 100,
      currentPage: 1,
      isBusy: false,
      hideSidePanel: false,

      isRunningQuery: false,
      isLoadingTemplate: false,
      jobtime: null,
      isLoadingJobTime: false,
      loadingCubeData: false,

      mdx: '',
    };
  },
  mounted() {
    this.GetCubes();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    rows() {
      return this.items.length;
    },
    fields() {
      let tableFields = [];
      const fields = [...this.selectedLevels, ...this.selectedMeasures];
      _.forEach(fields, function (item, index) {
        let field = {
          key: index.toString(),
          label: item.levelCaption || item.measureCaption,
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
        };
        if (item.measureDefaultFormat) {
          switch (item.measureDefaultFormat) {
            case 'INTEGER':
              field.formatter = 'FormatInteger';
              break;
            case 'PERCENTAGE':
              field.formatter = 'FormatPercentage';
              break;
            case 'DECIMAL':
              field.formatter = 'FormatDecimal';
              break;
            default:
              field.formatter = 'FormatMoney';
          }
          field.class = 'smartgrabber-measure';
          field.sortByFormatted = false;
        } else {
          if (item.levelDbType === 'MONTH1') {
            field.sortType = 'MONTH1';
          }
          if (item.levelDbType === 'MONTH2') {
            field.sortType = 'MONTH2';
          }
          field.class = 'smartgrabber-dimension';
        }
        tableFields.push(field);
      });
      return tableFields;
    },
    dragOptions() {
      return {
        animation: 100,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  watch: {
    selectedCube() {
      if (this.selectedCube) {
        this.cubedata = {};
        this.ResetSelectedData();
        this.GetCubeData();
        this.GetTemplates();
        this.GetJobTime();
      }
    },
    fields() {
      this.items = [];
    },
  },
  methods: {
    GetCubes() {
      this.axios.get('/api/datagrabber/').then(resp => {
        let cubes = [{value: null, text: 'Select'}];
        cubes = [...cubes, ..._.sortBy(resp.data, ['value'])];
        this.cubes = cubes;
      });
    },
    GetCubeType() {
      return _.find(this.cubes, {value: this.selectedCube}).type;
    },
    GetCubeData() {
      const vm = this;
      vm.loadingCubeData = true;
      vm.axios
          .get('/api/datagrabber/' + vm.selectedCube + '/configuration')
          .then(function (resp) {
            let cubedata = resp.data;

            //if marketing bonus does not exist, then add something here manually
            if (
                _.some(cubedata.measureGroups, {
                  measureGroupId: 'Fact Marketing Bonus',
                }) &&
                !_.some(cubedata.measureGroupDimension, item => {
                  return (
                      item.measureGroupId === 'Fact Marketing Bonus' &&
                      item.dimensionId !== '[Fact Marketing Bonus]'
                  );
                })
            ) {
              //manually get dimensions of Fact Marketing Bonus
              let betDimensions = _.filter(cubedata.measureGroupDimension, {
                measureGroupId: 'Fact Bet',
              });
              let bonusDimensions = _.filter(cubedata.measureGroupDimension, {
                measureGroupId: 'Fact Bonus',
              });
              let adjustmentDimensions = _.filter(
                  cubedata.measureGroupDimension,
                  {measureGroupId: 'Fact Adjustment'}
              );
              let rebateDimensions = _.filter(cubedata.measureGroupDimension, {
                measureGroupId: 'Fact Rebate',
              });
              let relatedDimensions = _.filter(betDimensions, dim => {
                return (
                    _.some(bonusDimensions, {dimensionId: dim.dimensionId}) &&
                    _.some(adjustmentDimensions, {
                      dimensionId: dim.dimensionId,
                    }) &&
                    _.some(rebateDimensions, {dimensionId: dim.dimensionId})
                );
              });
              let marketingBonusDimensions = _.map(relatedDimensions, dim => {
                return {
                  dimensionId: dim.dimensionId,
                  measureGroupId: 'Fact Marketing Bonus',
                };
              });
              cubedata.measureGroupDimension = [
                ...cubedata.measureGroupDimension,
                ...marketingBonusDimensions,
              ];
            }

            //if Fact Performance does not exist, then add something here manually
            if (
                _.some(cubedata.measureGroups, {
                  measureGroupId: 'Fact Performance',
                }) &&
                !_.some(cubedata.measureGroupDimension, item => {
                  return (
                      item.measureGroupId === 'Fact Performance' &&
                      item.dimensionId !== '[Fact Performance]'
                  );
                })
            ) {
              //manually get dimensions of Fact Marketing Bonus
              let betDimensions = _.filter(cubedata.measureGroupDimension, {
                measureGroupId: 'Fact Bet',
              });
              let transactionDimensions = _.filter(
                  cubedata.measureGroupDimension,
                  {
                    measureGroupId: 'Fact Transaction',
                  }
              );
              let relatedDimensions = _.filter(betDimensions, dim => {
                return _.some(transactionDimensions, {
                  dimensionId: dim.dimensionId,
                });
              });
              let performanceDimensions = _.map(relatedDimensions, dim => {
                return {
                  dimensionId: dim.dimensionId,
                  measureGroupId: 'Fact Performance',
                };
              });
              cubedata.measureGroupDimension = [
                ...cubedata.measureGroupDimension,
                ...performanceDimensions,
              ];
            }

            //if Fact Piwik Session Summary does not exist, then add something here manually
            if (
                _.some(cubedata.measureGroups, {
                  measureGroupId: 'Fact Piwik Session Summary',
                }) &&
                !_.some(cubedata.measureGroupDimension, item => {
                  return (
                      item.measureGroupId === 'Fact Piwik Session Summary' &&
                      item.dimensionId !== '[Fact Piwik Session Summary]'
                  );
                })
            ) {
              let dimensions = [
                  '[Dim Baimi Rating]',
                '[Dim Brand]',
                '[Dim Currency]',
                '[Dim Deposit Class]',
                '[Dim Life Cycle Backward]',
                '[Dim Lifetime Deposit Group]',
                '[Dim Player Preference Life Time]',
                '[Dim LTV Churn Status]',
                '[Dim Member]',
                '[Dim Player Transaction Preference]',
                '[Dim Game Platform]',
                '[Dim Player Frequency]',
                '[Dim Player Preference]',
                '[Dim Player Recency]',
                '[Dim Product Preference]',
                '[Dim Hour User Bet]',
                '[Dim Hour Vendor Settled]',
                '[Dim Hour]',
                '[Dim Piwik]',]
              let relatedDimensions = _.map(dimensions, (dimension) => {
                return {
                  dimensionId: dimension,
                  measureGroupId: 'Fact Piwik Session Summary',
                };
              });
              cubedata.measureGroupDimension = [
                ...cubedata.measureGroupDimension,
                ...relatedDimensions,
              ];
            }

            // _.each(cubedata.measureGroups, measureGroup => {
            //   if (
            //     !_.some(cubedata.measureGroupDimension, {
            //       measureGroupId: measureGroup.measureGroupId,
            //       dimensionId: '[Dim Hour]',
            //     })
            //   ) {
            //     cubedata.measureGroupDimension.push({
            //       measureGroupId: measureGroup.measureGroupId,
            //       dimensionId: '[Dim Hour]',
            //     });
            //   }
            // });

            vm.cubedata = cubedata;
          })
          .catch((error) => {
            if (error.response.data.message) {
              vm.$bvToast.toast(error.response.data.message, {
                title: 'Error connecting to cube',
                variant: 'warning',
                appendToast: true
              });
            }
          })
          .then(function () {
            vm.loadingCubeData = false;
          });
    },
    ResetSelectedData() {
      this.selectedMeasureGroups = [];
      this.selectedMeasures = [];
      this.selectedLevels = [];
      this.selectedFilters = [];
      this.selectedFilterOptions = [];
      this.items = [];
    },
    FormatMoney(value) {
      if (value) {
        return this.FormatNumber(value, 2);
      } else {
        return 0;
      }
    },
    FormatInteger(value) {
      if (value) {
        return this.FormatNumber(value, 0);
      } else {
        return 0;
      }
    },
    FormatPercentage(value) {
      if (value) {
        return (
            this.FormatNumber(value * 100, 2) + (value === 'Infinity' ? '' : ' %')
        );
      } else {
        return 0;
      }
    },
    FormatDecimal(value) {
      if (value) {
        let decimalPlaces = (value.toString().split('.')[1] || []).length;
        return this.FormatNumber(value, decimalPlaces < 7 ? decimalPlaces : 7);
      } else {
        return 0;
      }
    },
    FormatNumber(value, decimalplace) {
      if (null === decimalplace) {
        decimalplace = 2;
      }
      let dec = parseFloat(value).toFixed(decimalplace);
      let n = dec.toString(),
          p = n.indexOf('.');
      return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, function ($0, i) {
        return p < 0 || i < p ? $0 + ',' : $0;
      });
    },
    AddOrRemoveFilter(level, preselectedOptions) {
      const isExist = _.some(this.selectedFilters, function (v) {
        return v.level.levelId === level.levelId;
      });
      if (!isExist) {
        this.AddFilter(level, preselectedOptions);
      } else {
        this.RemoveFilter(level);
      }
    },
    AddFilter(level, preselectedOptions) {
      const vm = this;
      const isExist = _.some(this.selectedFilters, function (v) {
        return v.level.levelId === level.levelId;
      });
      if (!isExist) {
        let newFilter = {
          level: level,
          isLoading: false,
          cancelToken: '',
          isHierarchy: false,
          options: [],
        };
        vm.selectedFilters.push(newFilter);
        vm.selectedFilterOptions[level.levelId] = [];

        if (level.levelDbType === 'GENERAL') {
          newFilter.isLoading = true;
          const CancelToken = axios.CancelToken;
          const source = CancelToken.source();
          newFilter.cancelToken = source;

          //check if it is hierarchy
          newFilter.hierarchies = _.filter(vm.cubedata.levels, {
            hierarchyId: level.hierarchyId,
          });
          newFilter.isHierarchy = newFilter.hierarchies.length > 1;

          vm.axios
              .get('/api/datagrabber/' + vm.selectedCube + '/filteroptions', {
                params: level,
                cancelToken: source.token,
              })
              .then(function (resp) {
                if (resp.data) {
                  let options = _.cloneDeep(resp.data.options);
                  options = _.map(options, function (v) {
                    if (!v.text || !v.text.trim() || 0 === v.text.length) {
                      v.text = '(null)';
                    }
                    return v;
                  });
                  newFilter.options = options;
                  vm.selectedFilterOptions[level.levelId] =
                      preselectedOptions || [];
                }
              })
              .catch(function (ex) {
                if (axios.isCancel(ex)) {
                  // eslint-disable-next-line no-console
                  console.log('Filter request canceled', ex.message);
                } else {
                  // eslint-disable-next-line no-console
                  console.log('Filter request error', ex.message);
                  vm.RemoveFilter(level);
                  vm.PromptWarning(
                      'Failed to load ' + level.levelCaption,
                      'Failed to get data from server. Please try again.'
                  );
                }
              })
              .finally(function () {
                newFilter.isLoading = false;
              });
        } else if (level.levelId === '[Dim Brand].[Brand].[Brand]') {
          let ops = vm.selectedFilterOptions;
          ops[level.levelId] = preselectedOptions || [];
          vm.selectedFilterOptions = ops;
        }
      }
    },
    RemoveFilter(deleteLevel) {
      let level = _.cloneDeep(deleteLevel);
      let existingFilter = _.find(this.selectedFilters, function (filter) {
        return filter.level.levelId === level.levelId;
      });
      if (existingFilter.cancelToken) {
        existingFilter.cancelToken.cancel(
            'Removed filter before loading complete.'
        );
      }
      this.selectedFilters.splice(
          this.selectedFilters.findIndex(v => v === existingFilter),
          1
      );
      delete this.selectedFilterOptions[level.levelId];
    },
    GetQueryParameters() {
      const vm = this;
      let queryParams = {
        levels: _.cloneDeep(vm.selectedLevels),
        measures: _.cloneDeep(vm.selectedMeasures),
        filters: [],
      };
      _.forEach(vm.selectedFilters, function (filter) {
        let selectedOptions = _.map(
            vm.selectedFilterOptions[filter.level.levelId],
            function (f) {
              return {value: f, text: '-', group: '-'};
            }
        );
        if (selectedOptions && selectedOptions.length > 0) {
          queryParams.filters.push({
            level: filter.level,
            options: selectedOptions,
          });
        }
      });
      return queryParams;
    },
    ExportData() {
      const vm = this;
      const xhr = new XMLHttpRequest();

      xhr.open(
          'POST',
          '/api/datagrabber/' + vm.selectedCube + '/exportdata',
          true
      );
      xhr.responseType = 'arraybuffer';
      xhr.onerror = function () {
        vm.httpIsBusy = false;
        vm.isRunningQuery = false;
      };
      xhr.onload = function () {
        vm.httpIsBusy = false;
        vm.isRunningQuery = false;
        //if not success
        if (this.status !== 200) {
          if (this.status === 204) {
            vm.PromptWarning(
                'Empty result',
                'The result is empty. Please check the filter and try again.'
            );
          } else if (this.status === 400) {
            if (this.response) {
              vm.PromptWarning(
                  'Failed to get data',
                  'Connection timeout. Please add more filters to avoid long and heavy query.'
              );
            }
          } else {
            vm.PromptWarning(
                'Failed to get data',
                'Unknown error. Please try again.'
            );
          }
        }

        if (this.status === 200) {
          let filename = '';
          let disposition = xhr.getResponseHeader('Content-Disposition');
          if (disposition && disposition.indexOf('attachment') !== -1) {
            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            let matches = filenameRegex.exec(disposition);
            if (matches !== null && matches[1])
              filename = matches[1].replace(/['"]/g, '');
          }
          let type = xhr.getResponseHeader('Content-Type');

          let blob = new Blob([this.response], {type: type});
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created.
            // These URLs will no longer resolve as the data backing the URL has been freed."
            window.navigator.msSaveBlob(blob, filename);
          } else {
            let URL = window.URL || window.webkitURL;
            let downloadUrl = URL.createObjectURL(blob);

            if (filename) {
              // use HTML5 a[download] attribute to specify filename
              let a = document.createElement('a');
              // safari doesn't support this yet
              if (typeof a.download === 'undefined') {
                window.location = downloadUrl;
              } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
              }
            } else {
              window.location = downloadUrl;
            }

            setTimeout(function () {
              URL.revokeObjectURL(downloadUrl);
            }, 100); // cleanup
          }
        }

        //handle on complete
      };

      //handle before send
      xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
      vm.httpIsBusy = true;
      vm.isRunningQuery = true;
      xhr.send(JSON.stringify(vm.GetQueryParameters()));
    },
    GetData() {
      const vm = this;
      vm.isRunningQuery = true;
      vm.items = [];
      vm.axios
          .post(
              '/api/datagrabber/' + vm.selectedCube + '/grabdata',
              vm.GetQueryParameters()
          )
          .then(function (resp) {
            if (resp.status === 204) {
              vm.PromptWarning(
                  'Empty result',
                  'The result is empty. Please check the filter and try again.'
              );
            } else if (resp.data) {
              vm.items = resp.data;
            }
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.status === 400) {
                vm.PromptWarning(
                    'Failed to get data',
                    error.response.data.message
                );
              }
            } else {
              vm.PromptWarning(
                  'Failed to get data',
                  'Unknown error. Please try again.'
              );
            }
          })
          .then(function () {
            vm.isRunningQuery = false;
          });
    },
    GetTemplates() {
      const vm = this;
      vm.isLoadingTemplate = true;
      vm.axios
          .get('/api/datagrabber/' + vm.selectedCube + '/templates')
          .then(function (resp) {
            if (resp.data) {
              vm.templates = _.map(resp.data, function (v) {
                return {id: v.id, label: v.templateName};
              });
              vm.selectedTemplate = null;
            }
          })
          .catch(function () {
            vm.PromptWarning(
                'Failed to load templates',
                'Please refresh page to try again.'
            );
          })
          .then(function () {
            vm.isLoadingTemplate = false;
          });
    },
    AddOrEditTemplate() {
      const vm = this;
      const form = vm.$refs['template-form'];

      if (!form.reportValidity()) {
        return;
      }

      vm.modalTemplate = false;

      if (vm.isEditTemplate) {
        vm.$bvModal
            .msgBoxConfirm(
                'Proceed to update template? This will overwrite the exisitng template.',
                {centered: true}
            )
            .then(function (confirm) {
              if (confirm) {
                vm.EditTemplate();
              } else {
                vm.modalTemplate = true;
              }
            });
      } else {
        vm.$bvModal
            .msgBoxConfirm('Proceed to create template?', {centered: true})
            .then(function (confirm) {
              if (confirm) {
                vm.AddTemplate();
              } else {
                vm.modalTemplate = true;
              }
            });
      }
    },
    AddTemplate() {
      const vm = this;
      let template = {
        measureGroups: _.flatMap(vm.selectedMeasureGroups, function (v) {
          return v.measureGroupId;
        }),
        levels: _.flatMap(vm.selectedLevels, function (v) {
          return v.levelId;
        }),
        measures: _.flatMap(vm.selectedMeasures, function (v) {
          return v.measureId;
        }),
        filters: _.flatMap(vm.selectedFilters, function (v) {
          return v.level.levelId;
        }),
        filterOptions: _.chain(vm.selectedFilterOptions)
            .mapValues(function (v, k) {
              return {
                levelId: k,
                options: v,
              };
            })
            .values()
            .value(),
      };

      let formItem = Object.assign(_.cloneDeep(vm.template), {
        templateObject: JSON.stringify(template),
        cubeConfigId: vm.selectedCube,
      });

      vm.axios
          .post('/api/datagrabber/' + vm.selectedCube + '/templates', formItem)
          .then(function () {
            vm.PromptSuccess(
                'Success',
                'Template had been created successfully.'
            );

            vm.template = _.cloneDeep(vm.defaultTemplate);
            vm.GetTemplates();
          })
          .catch(function () {
            vm.PromptWarning(
                'Failed',
                'Failed to create template. Try to change the name if it is already in use.'
            );
          });
    },
    EditTemplate() {
      const vm = this;
      let template = {
        measureGroups: _.flatMap(vm.selectedMeasureGroups, function (v) {
          return v.measureGroupId;
        }),
        levels: _.flatMap(vm.selectedLevels, function (v) {
          return v.levelId;
        }),
        measures: _.flatMap(vm.selectedMeasures, function (v) {
          return v.measureId;
        }),
        filters: _.flatMap(vm.selectedFilters, function (v) {
          return v.level.levelId;
        }),
        filterOptions: _.chain(vm.selectedFilterOptions)
            .mapValues(function (v, k) {
              return {
                levelId: k,
                options: v,
              };
            })
            .values()
            .value(),
      };

      let formItem = Object.assign(_.cloneDeep(vm.template), {
        templateObject: JSON.stringify(template),
        cubeConfigId: vm.selectedCube,
      });

      vm.axios
          .put(
              '/api/datagrabber/' + vm.selectedCube + '/templates/' + formItem.id,
              formItem
          )
          .then(function () {
            vm.PromptSuccess(
                'Success',
                'Template had been updated successfully.'
            );
            vm.modalTemplate = false;
            vm.template = _.cloneDeep(vm.defaultTemplate);
            vm.GetTemplates();
          })
          .catch(function () {
            vm.PromptWarning(
                'Failed',
                'Failed to update template. Please try again.'
            );
          });
    },
    DeleteTemplate() {
      const vm = this;

      vm.$bvModal
          .msgBoxConfirm(
              'Proceed to delete template? Deleted data will be lost forever.',
              {centered: true}
          )
          .then(function (confirm) {
            if (confirm) {
              vm.axios
                  .delete(
                      '/api/datagrabber/' +
                      vm.selectedCube +
                      '/templates/' +
                      vm.editTemplate.id
                  )
                  .then(function () {
                    vm.PromptSuccess(
                        'Success',
                        'Template had been deleted successfully.'
                    );
                    vm.modalTemplate = false;
                    vm.template = _.cloneDeep(vm.defaultTemplate);
                    vm.GetTemplates();
                  })
                  .catch(function () {
                    vm.PromptWarning(
                        'Failed',
                        'Failed to delete template. Please try again.'
                    );
                  });
            }
          });
    },
    LoadTemplate() {
      const vm = this;
      vm.axios
          .get(
              '/api/datagrabber/' +
              vm.selectedCube +
              '/templates/' +
              vm.selectedTemplate
          )
          .then(function (resp) {
            if (resp.data) {
              let template = JSON.parse(resp.data.templateObject);

              vm.editTemplate = {
                id: resp.data.id,
                templateName: resp.data.templateName,
              };

              vm.ResetSelectedData();
              //Load MeasureGroups
              vm.selectedMeasureGroups = _.filter(
                  _.map(template.measureGroups, function (v) {
                    return _.find(vm.cubedata.measureGroups, {measureGroupId: v});
                  }),
                  function (v) {
                    return v;
                  }
              );

              return template;
            }
          })
          .then(template => {
            if (template) {
              if (vm.selectedMeasureGroups.length > 0) {
                //Load SelectedLevels
                vm.selectedLevels = _.filter(
                    _.map(template.levels, function (v) {
                      return _.find(vm.cubedata.levels, {levelId: v});
                    }),
                    function (v) {
                      return v;
                    }
                );
                //Load SelectedMeasures
                vm.selectedMeasures = _.filter(
                    _.map(template.measures, function (v) {
                      return _.find(vm.cubedata.measures, {measureId: v});
                    }),
                    function (v) {
                      return v;
                    }
                );
                //Load SelectedFilters
                let selectedOptions = {};
                _.forEach(template.filterOptions, function (v) {
                  vm.AddOrRemoveFilter(
                      _.find(vm.cubedata.levels, {levelId: v.levelId}),
                      v.options
                  );
                });
                //Load SelectedFilterOptions
                vm.selectedFilterOptions = selectedOptions;
              }
            }
          });
    },
    GetJobTime() {
      const vm = this;
      const selectedCube = vm.selectedCube;
      vm.jobtime = null;
      vm.isLoadingJobTime = true;
      vm.axios
          .get('/api/datagrabber/' + vm.selectedCube + '/jobtime')
          .then(function (resp) {
            if (resp.data) {
              if (selectedCube === vm.selectedCube) {
                vm.jobtime = resp.data;
              }
            }
          })
          .catch((error) => {
            if (error.response.data.message) {
              vm.$bvToast.toast(error.response.data.message, {
                title: 'Error getting job time',
                variant: 'warning',
                appendToast: true
              });
            }
          })
          .then(()=> {
            vm.isLoadingJobTime = false;
          });
    },
    GetMdxQuery() {
      const vm = this;
      vm.isRunningQuery = true;
      vm.axios
          .post(
              '/api/datagrabber/' + vm.selectedCube + '/mdxquery',
              vm.GetQueryParameters()
          )
          .then(function (resp) {
            if (resp.status === 204) {
              vm.PromptWarning(
                  'Empty result',
                  'The result is empty. Please check the filter and try again.'
              );
            } else if (resp.data.trim()) {
              const h = vm.$createElement;
              const body = h(
                  'textarea',
                  {class: 'form-control smartgrabber-mdx-query'},
                  resp.data.trim().replace(/\s\s+/g, ' ')
              );
              vm.$bvModal.msgBoxOk([body], {
                buttonSize: 'sm',
                centered: true,
                size: 'lg',
              });
            }
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.status === 400) {
                vm.PromptWarning(
                    'Failed to get data',
                    error.response.data.message
                );
              }
            } else {
              vm.PromptWarning(
                  'Failed to get data',
                  'Unknown error. Please try again.'
              );
            }
          })
          .then(function () {
            vm.isRunningQuery = false;
          });
    },
    retrieveMdx() {
      this.mdx = '';
      const vm = this;
      vm.axios
          .post(
              '/api/datagrabber/' + vm.selectedCube + '/mdxquery',
              vm.GetQueryParameters()
          )
          .then(resp => {
            if (resp.data.trim()) {
              vm.mdx = resp.data.trim().replace(/\s\s+/g, ' ');
            }
          })
          .catch(() => {
            vm.mdx = '';
          });
    },
    saveDataset(formItem) {
      const vm = this;
      const queryParameter = vm.GetQueryParameters();
      const dataset = {
        datasetName: formItem.datasetName,
        datasetQuery: this.mdx,
        datasetQueryParameters: JSON.stringify(queryParameter),
        cubeConfigId: this.selectedCube,
        datasetFields: JSON.stringify(this.fields),
        datasetCachedData: JSON.stringify(this.items),
        datasetLastUpdatedDateTime: new Date().toISOString(),
        isPrivate: formItem.isPrivate,
      };

      vm.axios
          .post('/api/datasets', dataset)
          .then(() => {
            vm.PromptSuccess('Success', 'Dataset had been saved successfully.');
          })
          .catch(() => {
            vm.PromptWarning(
                'Failed',
                'Failed to save dataset. Please try again.'
            );
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.smartgrabber-list-item {
  width: 100%;
  font-size: 0.9em;
  font-weight: 300;
}

.smartgrabber-panel {
  //height: calc(100vh - 130px);
  //max-height: calc(100vh - 130px);
  //overflow-x: hidden;
  //overflow-y: auto;
}

.smartgrabber-panel-hidden {
  display: none;
}

.smartgrabber-divider {
  //max-height: calc(100vh - 100px);
  min-height: calc(100vh - 100px);
  max-width: 30px;
  padding: 3px 3px 3px 0;
  border-left: 2px solid #ebebeb;
}

.smartgrabber-hide-options {
  display: inline-block;
  cursor: pointer;
  padding: 5px 5px 5px 2px;
  margin-left: -2px;
  border: 2px solid #ebebeb;
  color: #bebebe;
  border-left: 2px solid #fff;
  border-radius: 0 8px 8px 0;
  z-index: 2;
  background-color: #ffffff;

  &:hover {
    font-size: 18px;
  }
}

.smartgrabber-hide-results {
  display: inline-block;
  cursor: pointer;
  padding: 5px 5px 5px 2px;
  border: 2px solid #bebebe;
  border-radius: 0 8px 8px 0;
  border-left: none;

  &:hover {
    background-color: #bebebe;
  }
}
</style>

<style lang="scss">
.max-width-170 {
  max-width: 170px !important;
}

.max-width-150 {
  max-width: 150px !important;
}

.max-width-50 {
  max-width: 50px !important;
}

.clickable {
  cursor: pointer;
  font-weight: bolder;

  &:hover {
    color: #212529 !important;
    background-color: #007bff08;
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

@mixin width {
  width: auto !important;
}

table {
  &.table-fit {
    @include width;
    table-layout: auto !important;

    thead th,
    tfoot th {
      font-size: 0.75em;
      font-weight: 300;
      cursor: grab;
      @include width;

      &:active {
        cursor: grabbing;
      }
    }

    tbody td,
    tfoot td {
      @include width;
    }
  }
}

.smartgrabber-dimension {
  color: #007bff !important;
}

.smartgrabber-measure {
  color: #17a2b8 !important;
  text-align: right;
}

.smartgrabber-mdx-query {
  min-height: 300px;
  font-size: 0.75em !important;
}

.smartgrabber-table {
  font-size: 0.85em !important;
}
</style>